const initialState = {
  FunctionCalled: false,
}

export default function nextFunctionCalledReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case "NEXT_FUNCTION_CALLED":
      return {
        ...state,

        FunctionCalled: action.payload.FunctionCalled,
      }
    default:
      return state
  }
}

